import clsx from "clsx";

type Props = {
  value?: boolean;
  onClick?: (value: boolean) => void;
  variant?: "primary" | "black";
};

export default function CommonTextSwitch({
  value,
  onClick,
  variant = "primary",
}: Props) {
  return (
    <div className="p-[2px]" onClick={() => onClick?.(!value)}>
      <div
        className={clsx([
          "relative rounded-full w-[65px] h-[34px]",
          {
            "bg-brand-neutral-50": !value,
            "bg-brand-floating-primary-button": value && variant === "primary",
            "bg-black": value && variant === "black",
          },
        ])}
      >
        <div
          className={clsx(
            "h-[32px] w-[32px] bg-white rounded-full transition-all absolute top-1/2 -translate-y-1/2",
            {
              "translate-x-[1px]": !value,
              "translate-x-[32px]": value,
            }
          )}
        />
        <div className="absolute flex justify-between items-center w-full h-full px-2.5 text-white text-xs">
          <span
            className={clsx("transition-opacity duration-300", {
              "opacity-100": value,
              "opacity-0": !value,
            })}
          >
            On
          </span>
          <span
            className={clsx("transition-opacity duration-300", {
              "opacity-0": value,
              "opacity-100": !value,
            })}
          >
            Off
          </span>
        </div>
      </div>
    </div>
  );
}
